import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { useLocation } from 'wouter'
import { ArrowLeft } from 'lucide-react'
import Navbar from '@/components/navbar'
import Footer from '@/components/footer'

export default function ShopriteCompetitionTermsPage() {
  const [, navigate] = useLocation()

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      <div className="container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto">
          <Button
            variant="ghost"
            onClick={() => navigate('/')}
            className="mb-6"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Back to Home
          </Button>

          <Card>
            <CardHeader>
              <CardTitle className="text-3xl font-bold text-center">
                R2000 Shoprite Voucher Competition Terms
              </CardTitle>
              <p className="text-muted-foreground text-center">
                Competition Terms and Conditions
              </p>
            </CardHeader>
            <CardContent className="prose max-w-none space-y-6">
              <div className="space-y-6">
                <section>
                  <h2 className="text-2xl font-semibold mb-4">Competition Terms</h2>

                  <div className="space-y-4">
                    <p>
                      Open to South African residents aged 18+ with a valid SA ID. Employees or affiliates may not enter.
                    </p>

                    <p>
                      To enter, complete the form and agree to be contacted about financial offers. You may share your unique referral link for extra entries.
                    </p>
                  </div>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold mb-4">Prizes</h2>

                  <div className="space-y-3">
                    <div className="bg-blue-50 border-l-4 border-blue-500 p-4 rounded">
                      <p className="font-semibold text-blue-900 mb-2">Solo Winner:</p>
                      <p className="text-blue-800">R1 000 Shoprite voucher</p>
                    </div>

                    <div className="bg-green-50 border-l-4 border-green-500 p-4 rounded">
                      <p className="font-semibold text-green-900 mb-2">Referral Winners:</p>
                      <ul className="list-disc list-inside space-y-1 text-green-800">
                        <li>Referrer gets R2 000 voucher</li>
                        <li>Referred friend gets R1 000 voucher</li>
                      </ul>
                    </div>
                  </div>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold mb-4">Winner Selection</h2>

                  <p>
                    Winners are selected randomly and notified within 7 days. Unclaimed prizes may be forfeited.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold mb-4">Consent and Data Usage</h2>

                  <p>
                    By entering, you consent to being contacted about financial products and agree your anonymised data may be used for analysis. No loan applications are created — all loans remain subject to NCR rules.
                  </p>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold mb-4">Governing Law</h2>

                  <p>
                    This competition is governed by South African law. Participation implies acceptance of these terms and the <a href="/terms" className="text-primary hover:underline">Prize Drop Terms & Conditions</a>.
                  </p>
                </section>

                <div className="mt-8 p-6 bg-gray-100 rounded-lg border border-gray-300">
                  <p className="text-sm text-gray-700 text-center">
                    For any questions or concerns regarding this competition, please contact us at{' '}
                    <a href="mailto:support@prizedrop.co.za" className="text-primary hover:underline">
                      support@prizedrop.co.za
                    </a>
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>

      <Footer />
    </div>
  )
}
